import React from 'react'
import { Icon as FormBuilderIcon } from '@enamelai/design-system/icons/Form_builder'

/** DS form builder icon; its fill follows the row color via `.template-item-icon`. */
const FormIcon: React.FC = () => (
  <FormBuilderIcon className="template-item-icon" aria-hidden="true" />
)

export default FormIcon
